export default __webpack_public_path__ + "static/media/369.9b5c3ad8.png";